 export const LogList=[
    {
        prop:"DJBH",
        label:"单价编号",
        width:"150",
        isShow:true,
        order: true
    },
    {
        prop:"Message",
        label:"错误信息",
        width:"150",
        isShow:true
    },
    {
        prop:"action",
        label:"请求路径",
        width:"150",
        isShow:true
    },
    {
        prop:"ExceptionStackTrace",
        label:"错误堆栈信息",
        width:"150",
        isShow:true
    },
    {
        prop:"ExceptionJson",
        label:"异常JSON",
        width:"150",
        isShow:true
    },
    {
        prop:"CreateTime",
        label:"创建时间",
        width:"150",
        isShow:true,
        order: true,
    }
 ]



